// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = require("!!../../style-loader/index.js!../../css-loader/index.js!./leaflet.css");

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-to-string-loader!./~/leaflet/dist/leaflet.css
 ** module id = 933
 ** module chunks = 0
 **/